
        import { NgModule } from '@angular/core';
        import { CommonModule } from '@angular/common';
        import { RouterModule } from '@angular/router';
        import { StatePreviewComponent } from './components/state-preview/state.preview.component';
        
        @NgModule({
          imports: [CommonModule],
          declarations: [StatePreviewComponent],
          exports: [StatePreviewComponent]
        })
        export class StatePreviewModule { }
        